import { render, staticRenderFns } from "./Zyfw.vue?vue&type=template&id=46e20255&scoped=true&"
import script from "./Zyfw.vue?vue&type=script&lang=js&"
export * from "./Zyfw.vue?vue&type=script&lang=js&"
import style0 from "./Zyfw.vue?vue&type=style&index=0&id=46e20255&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e20255",
  null
  
)

export default component.exports